import React, { Suspense } from "react";
import {
  EuiFormFieldset,
  EuiPanel,
  EuiSpacer,
  EuiIconTip,
  EuiAccordion,
  EuiTabbedContentTab,
} from "@elastic/eui";
import { MarkdownText } from "../markdown_text";
import { useAnketa } from "../context_provider";
import { GroupCardProps } from "src/questionnaires/types";
import { Group } from "anketa-core/group";
import { TabTitle } from "../tab_title";

export const GroupCard = ({ group }: GroupCardProps): JSX.Element => {
  const ctx = useAnketa();

  if (!group.visible) {
    return <div></div>;
  }
  let description;
  if (group.description) {
    description = <MarkdownText text={group.description} />;
  }
  return (
    <>
      <EuiAccordion
        id={group.id}
        buttonContent={ctx.i18nContext.render(group.title)}
      >
        <EuiPanel>
          <EuiFormFieldset key={group.id}>
            {group.help && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                }}
              >
                <EuiIconTip
                  aria-label={group.id}
                  size="m"
                  type="questionInCircle"
                  color="primary"
                  content={ctx.i18nContext.render(group.help)}
                />
              </div>
            )}
            {description}
            {ctx.childrenForItem(group)}
          </EuiFormFieldset>
        </EuiPanel>
      </EuiAccordion>
      <EuiSpacer />
    </>
  );
};

const GetGroupTabContent = ({
  group,
  parentId,
}: {
  group: Group;
  parentId: string;
}): JSX.Element => {
  const ctx = useAnketa();

  let description;
  if (group.description) {
    description = <MarkdownText text={group.description} />;
  }

  return (
    <EuiFormFieldset key={`tab-content-${parentId}-content`}>
      {group.help && (
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <EuiIconTip
            aria-label={group.id}
            size="m"
            type="questionInCircle"
            color="primary"
            content={ctx.i18nContext.render(group.help)}
          />
        </div>
      )}
      {description}
      {ctx.childrenForItem(group)}
    </EuiFormFieldset>
  );
};
export const getGroupTab = ({
  group,
  parentId,
}: {
  group: Group;
  parentId: string;
}): EuiTabbedContentTab => {
  return {
    id: `tab-${group.id}`,
    name: <TabTitle item={group} />,
    content: (
      <GetGroupTabContent group={group} parentId={`${parentId}-${group.id}`} />
    ),
  };
};
